module.exports = __webpack_public_path__ + "static-v-shop/1783947756939/img/logo_master.c8bdcd8d.svg";